import { defineMessages } from 'react-intl';
export default defineMessages({
    legendHeavy: {
        id: 'weatherMap.legendHeavy',
        defaultMessage: 'Heavy'
    },
    legendLight: {
        id: 'weatherMap.legendLight',
        defaultMessage: 'Light'
    },
    legendLightningHelp: {
        id: 'weatherMap.legendLightningHelp',
        defaultMessage: "Colour shows each strike's age over the last {minutes} minutes — most recent in white, oldest in dark red."
    },
    legendNewest: {
        id: 'weatherMap.legendNewest',
        defaultMessage: 'Newest'
    },
    legendOldest: {
        id: 'weatherMap.legendOldest',
        defaultMessage: 'Oldest'
    },
    legendStationsHelp: {
        id: 'weatherMap.legendStationsHelp',
        defaultMessage: 'Marker colour reflects the value of the selected metric.'
    },
    lightningDataAttribution: {
        id: 'weatherMap.lightningDataAttribution',
        defaultMessage: 'Lightning data: Blitzortung.org'
    },
    lightningStrikes: {
        id: 'weatherMap.lightningStrikes',
        defaultMessage: 'Lightning strikes'
    },
    lightningStrikesDescription: {
        id: 'weatherMap.lightningStrikesDescription',
        defaultMessage: 'Display real-time lightning strikes on the map'
    },
    mapLayers: {
        id: 'weatherMap.mapLayers',
        defaultMessage: 'Map layers'
    },
    mapLegend: {
        id: 'weatherMap.mapLegend',
        defaultMessage: 'Map legend'
    },
    radarDataAttribution: {
        id: 'weatherMap.radarDataAttribution',
        defaultMessage: 'Radar data: NOAA / EUMETNET OPERA via LibreWXR'
    },
    rainRadar: {
        id: 'weatherMap.rainRadar',
        defaultMessage: 'Rain radar'
    },
    rainRadarDescription: {
        id: 'weatherMap.rainRadarDescription',
        defaultMessage: 'Display rain radar overlay on the map'
    },
    weatherflowNCRain: {
        id: 'weatherMap.weatherflowNCRain',
        defaultMessage: 'NC Rain (Nearcast Rain)'
    },
    weatherflowNCRainDescription: {
        id: 'weatherMap.weatherflowNCRainDescription',
        defaultMessage: 'NC Rain is an additional data source provided via the Tempest Weather System, powered by Nearcast Technology. NC Rain data is an estimate of the average rainfall accumulation around your Tempest at the neighborhood level'
    },
    weatherMap: {
        id: 'weatherMap.weatherMap',
        defaultMessage: 'Weathermap'
    },
    weatherMapMetaDescription: {
        id: 'weatherMap.weatherMapMetaDescription',
        defaultMessage: 'SmartMixin provides interactive weather and radar maps for weather conditions for locations worldwide.'
    }
});
